module.exports = __webpack_public_path__ + "media/images/yelling-reverse-f83ee0880d75658a683add0091f6ede2.svg";